import { useUpdateEntityAppearance } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateEntityAppearance'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { CheckboxNew } from 'src/editor/shared/ui-lib/checkbox-new'
import { AppearanceEntityInterface } from 'src/shared/schemas/appearance'

interface DeviceAppearanceNewProps<T extends AppearanceEntityInterface> {
  entity: T
}

function DeviceAppearanceNew<T extends AppearanceEntityInterface>({
  entity,
}: DeviceAppearanceNewProps<T>) {
  const { appearance = { desktop: true, mobile: true } } = entity

  const updateAppearance = useUpdateEntityAppearance(entity)
  const toggleDesktop = () =>
    updateAppearance({
      desktop: !appearance.desktop,
      mobile: appearance.desktop ? true : appearance.mobile,
    })

  const toggleMobile = () =>
    updateAppearance({
      desktop: appearance.mobile ? true : appearance.desktop,
      mobile: !appearance.mobile,
    })

  return (
    <>
      <GroupTitle>settings_options.device_appearance.label</GroupTitle>
      <CheckboxNew
        wrapperClassName="mt-4"
        label="settings_options.device_appearance.desktop"
        onChange={toggleDesktop}
        checked={appearance.desktop}
      />
      <CheckboxNew
        wrapperClassName="mt-3"
        label="settings_options.device_appearance.mobile"
        onChange={toggleMobile}
        checked={appearance.mobile}
      />
    </>
  )
}

export default DeviceAppearanceNew
